import { userConstants } from "../constants/login.constants";

 function directorIdReport(state = {}, action) {
    switch (action.type) {
        case userConstants.DIRECTORIDREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.DIRECTORIDREPORT_SUCCESS:
            return {
                items: action.directorIdReport
            };
        case userConstants.DIRECTORIDREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default directorIdReport;